import { useEffect } from 'react';
import { ulid } from 'ulid';

import { useDestinations } from '@/features/destinations/api/getDestinations';
import useInBranchPreselection from '@/hooks/useInBranchPreselection';
import useProceedWithDestination from '@/hooks/useProceedWithDestination';
import useAppointmentStore from '@/store/AppointmentStore';
import useSessionStore from '@/store/SessionStore';
import { FlowType } from '@/types/FlowType';
import useAuthUserInfo from './useAuthUserInfo';

const useLandingPageSetup = (flow: FlowType) => {
  const { sessionId, setFlowType, setSessionId, setSessionSource } =
    useSessionStore();

  const setDestinations = useAppointmentStore((state) => state.setDestinations);

  const destinationsQuery = useDestinations();
  const { userInfoQuery } = useAuthUserInfo();
  useInBranchPreselection();

  const proceedWithDestination = useProceedWithDestination(flow);

  useEffect(() => {
    if (flow === FlowType.EMAIL) {
      setFlowType('emailInquiry');
    }
  }, [flow, setFlowType]);

  useEffect(() => {
    if (destinationsQuery.isSuccess && !sessionId) {
      setSessionId(ulid());
      setSessionSource('new');
    }
  }, [destinationsQuery.isSuccess, sessionId, setSessionId, setSessionSource]);

  useEffect(() => {
    if (destinationsQuery.data?.length) {
      setDestinations(destinationsQuery.data);
    }
  }, [destinationsQuery.data, setDestinations]);

  return {
    proceedWithDestination,
    destinationsQuery,
    userInfoQuery,
  };
};

export default useLandingPageSetup;
